<template>
    <div id="wrap" class="skpfull_wrap">
        <div class="rd_box register">

            <div class="container register step2">
				<div class="title">
					<h1>Insert Terms & Conditions</h1>
				</div>
				<div class="content" ng-init="">
					<div class="one-register">
                        <div class="input-rows">
                            <fieldset class="step_set">
                                <div class="one-input-container">
                                    <label>국가</label>
                                    <input type="text" v-model="countryCd"/>
                                </div>
                                <div class="one-input-container">
                                    <label>언어</label>
                                    <input type="text" v-model="langCdd"/>
                                </div>
                                <div class="one-input-container">
                                    <label>제목</label>
                                    <input type="text" v-model="title"/>
                                </div>
                                <div class="one-input-container">
                                    <label for="idCont">약관내용</label>
                                    <textarea id="idConst" v-model="contents" rows="20"></textarea>
                                </div>

                            </fieldset>
                        </div>

                        <div class="one-btn-wrap">
                            <button class="bt-type-b next" @click="saveTerms">{{$t('BUTTON.GLOBAL.SAVE')}}</button>
                        </div>

					</div>
				</div>
			</div>
        </div>
    </div>
</template>

<script>

import Vue              from 'vue';
import { SDLUtil }      from '@/utils';
import { mapGetters }   from 'vuex';
import qs               from 'query-string';
import axios            from 'axios';
import store            from '@/vuex/store';
import ConfirmPopup     from './JoinedConfirmPopup';
import { i18n, loadLanguageAsync } from '@/i18n';

export default {
    name: 'EurJoinUserStep2',
    computed: {
        ...mapGetters({
            guid      : 'getGuid',    // GUID
            email     : 'getEmail',
            loginCountryCd : 'getLoginCountryCd',
            langCd    : 'getLangCd'
        })
    },
    data() {
        return {
            langNm: '',
            countryNm : '',
            countryLangNm : '',
            langNm : '',
            companyNm: '',
            companyNo: '',
            zipCd: '',
            address: '',
            homeUrl: '',
            contactFrstNm: '',
            contactLastNm: '',
            contactPhoneNo: '',
            apeCodes: '',
            attachFile1Name: '', // Insurance Cetificate Name
            attachFile1Size: '', // Insurance Cetificate Size
            attachFile2Name: '', // Company Regist License Name
            attachFile2Size: '', // Company Regist License Size
            countryCdList: [],
            langCdList: [],

            countryCd : '',
            langCdd: '',
            title: '',
            contents: ''

        };
    },
    methods: {
        // validation
        userValidateion() {
            let bRes = true;

            if (this.companyNo.length < 5) {
                $('.userEmail').removeClass('error');
                $('.companyNo').addClass('error');
                return false;
            }

            let valids  = [this.companyNm, this.companyNo, this.address, this.zipCd, this.contactFrstNm
                         , this.contactLastNm, this.contactPhoneNo, this.attachFile1Name, this.attachFile2Name];
            let classNm = ['companyNm', 'companyNo', 'address', 'zipCd', 'contactFrstNm', 'contactLastNm'
                         , 'contactPhoneNo', 'attachFile1', 'attachFile2'];
            if (this.loginCountryCd == 'FR') { // 프랑스일 때만 APE Codes 체크
                valids.push(this.apeCodes);
                classNm.push('apeCodes');
            }
            $.each(valids, function(idx, elm) {
                if (!elm) {
                    $('.' + classNm[idx]).addClass('error');
                    bRes = false;
                    return false;
                } else {
                    $('.' + classNm[idx]).removeClass('error');
                }
            });

            let fileTotalSize = (Number(this.attachFile1Size) + Number(this.attachFile2Size)) / 1000;
            if (fileTotalSize > 10000) {
                SDLUtil.alert('MESSAGE.EUR.FILE.LESS.10MB');
                bRes = false;
            }

            return bRes;
        },
        async saveTerms() {
            SDLUtil.showLoadingBar(true);
            let joinData = {
                countryCd   : this.countryCd,
                langCdd     : this.langCdd,
                title       : this.title,
                contents    : this.contents,
            };
            console.log('joinData ===> ', joinData);

            const url = `${SDLUtil.API_URL}/noauth/eur/insertTerms.skp`;
            return await axios.post(url, 
                    qs.stringify(joinData), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }).then(resp => {
                    SDLUtil.showLoadingBar(false);
                    console.log('login.resp.data ===> ', resp.data);
                        Vue.toasted.show(
                            SDLUtil.getMsgProp('MESSAGE.SUCCESS.SAVED'), {
                                theme: "toasted-primary",
                                position: "top-center",
                                duration : 3000
                            }
                        );

                    // 가입과 동시에 로그인 되게...
                })
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                    console.log('Err.Save ==> ', err);
                    SDLUtil.errorAlert(err);
                });
        },
        goBackStep1() {
            let pathUrl = `${SDLUtil.WEB_CONTEXT_PATH}/erp/joinUserStep1`;
            this.$router.push({ path: pathUrl, query: {}});
        },
        goNextStep3() {
            let pathUrl = `${SDLUtil.WEB_CONTEXT_PATH}/erp/joinUserStep3`;
            this.$router.push({ path: pathUrl, query: {}});
        },
    },
    created() {
    },
    mounted() {
        this.countryNm = localStorage.getItem('eur.user.country.name');
        this.langNm    = localStorage.getItem('eur.user.lang.name');
        this.countryLangNm = this.countryNm + ' / ' + this.langNm;
        console.log('this.countryLangNm ===> ', this.countryLangNm);
    },
    watch: {
        errorState() {
            alert(this.errorState.code);
            this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/error` });
        },
    },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/user/InsertTermsCond.vue